/**
 * @generated SignedSource<<be4b7267659f415c643a020678f573bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountQuery$variables = {
  id: string;
};
export type accountQuery$data = {
  readonly account: {
    readonly accountDetailConnect: {
      readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailInlineFragment" | "accountConnectDetailFragment">;
    };
    readonly accountBillingInfos: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"accountBillingInfoBaseFragment" | "accountBillingInfoCardFragment" | "accountBillingInfoAddressFragment">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment" | "accountBaseFragment" | "accountAddressFragment" | "accountDetailsFragment" | "accountFinancialFragment">;
  };
};
export type accountQuery = {
  variables: accountQuery$variables;
  response: accountQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformAccess",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetSubdomain",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "accountBaseInlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accountBaseFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accountAddressFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accountDetailsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "accountFinancialFragment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDetailConnect",
            "kind": "LinkedField",
            "name": "accountDetailConnect",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "accountConnectDetailInlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountConnectDetailFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountBillingInfo",
            "kind": "LinkedField",
            "name": "accountBillingInfos",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoBaseFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoCardFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoAddressFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressLineOne",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressLineTwo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zip",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urls",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "businessLogoUrls",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverPhotoUrls",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paypalDetails",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeDetails",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeRef",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDetailConnect",
            "kind": "LinkedField",
            "name": "accountDetailConnect",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountBillingInfo",
            "kind": "LinkedField",
            "name": "accountBillingInfos",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "extraBillingInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardBrand",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardLastFour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardCountryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingAddressLineOne",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingAddressLineTwo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingCountryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingZip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "billingCountry",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeTwo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeThree",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "continentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySymbol",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37eeb8f2403baf778ab170fd271b447a",
    "id": null,
    "metadata": {},
    "name": "accountQuery",
    "operationKind": "query",
    "text": "query accountQuery(\n  $id: ID!\n) {\n  account(id: $id) {\n    ...accountBaseInlineFragment\n    ...accountBaseFragment\n    ...accountAddressFragment\n    ...accountDetailsFragment\n    ...accountFinancialFragment\n    accountDetailConnect {\n      ...accountConnectDetailInlineFragment\n      ...accountConnectDetailFragment\n      id\n    }\n    accountBillingInfos {\n      ...accountBillingInfoBaseFragment\n      ...accountBillingInfoCardFragment\n      ...accountBillingInfoAddressFragment\n      id\n    }\n    id\n  }\n}\n\nfragment accountAddressFragment on Account {\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  countryId\n  zip\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountBaseInlineFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountBillingInfoAddressFragment on AccountBillingInfo {\n  billingAddressLineOne\n  billingAddressLineTwo\n  billingCity\n  billingState\n  billingCountryId\n  billingZip\n  billingCountry {\n    ...countryFragment\n    id\n  }\n}\n\nfragment accountBillingInfoBaseFragment on AccountBillingInfo {\n  id\n  extraBillingInformation\n}\n\nfragment accountBillingInfoCardFragment on AccountBillingInfo {\n  cardBrand\n  cardLastFour\n  cardCountryId\n}\n\nfragment accountConnectDetailFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n\nfragment accountConnectDetailInlineFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n\nfragment accountDetailsFragment on Account {\n  website\n  urls\n  description\n  phone\n  businessLogoUrls\n  coverPhotoUrls\n}\n\nfragment accountFinancialFragment on Account {\n  paypalDetails\n  stripeDetails\n  stripeRef\n}\n\nfragment countryFragment on Country {\n  name\n  isoCodeTwo\n  isoCodeThree\n  continentName\n  currency\n  currencySymbol\n}\n"
  }
};
})();

(node as any).hash = "ab9873d44441faf45a5f4c6a8540fa8e";

export default node;
